/* assets/poster-workbench.js
 *
 * The Bouquet/Vase tuning workbench, lifted out of sections/admin-poster-review.liquid.
 * That section hit Shopify's hard 256 KB template limit, and every push past it was
 * REJECTED while the CLI still printed "pushed successfully" and exited 0 -- so changes
 * silently never reached live. An asset has no such limit.
 *
 * The four values that were Liquid now arrive through the #ba-config JSON tag the
 * section renders, so this file is static and cacheable.
 */
var CFG = (function () {
  try { return JSON.parse(document.getElementById("ba-config").textContent) || {}; }
  catch (e) { return {}; }
})();
document.addEventListener("DOMContentLoaded", function () {
  // This tab tunes BOTH posters. The vase renderer is a fork of the bouquet one with the
  // same public API, so the whole workbench -- palette, canvas, nudge keys, JSON in/out --
  // works against either by swapping which renderer and which storefront product it reads.
  // Duplicating the tab would have meant maintaining two copies of every tuning control.
  var MODES = {
    bouquet: {
      label: "Bouquet",
      renderer: function () { return window.FlowerBouquetRenderer; },
      asset: "flower-poster-renderer.js",
      handle: CFG.bouquetHandle || "personalized-family-bouquet",
      section: CFG.bouquetSection || "flower_poster_BCnrV7"
    },
    vase: {
      label: "Vase",
      renderer: function () { return window.FlowerVaseRenderer; },
      asset: "flower-vase-renderer.js",
      handle: CFG.vaseHandle || "together-we-bloom",
      section: CFG.vaseSection || ""
    }
  };
  var MODE = "bouquet";

  // The orders script has its own copy of this. The two script blocks are separate
  // scopes on purpose, so a helper defined in one is NOT visible in the other -- which
  // is exactly how Import order came to throw "isBouquetFamily is not defined".
  function isBouquetFamily(o) {
    return !!o && (o.poster_type === "flower-bouquet" || o.poster_type === "flower-vase");
  }
  var R = MODES.bouquet.renderer();
  var HANDLE = MODES.bouquet.handle;
  var SECTION = MODES.bouquet.section;

  var root = document.getElementById("ba-root");
  if (!R || !root) { if (root) { var s0 = document.getElementById("ba-status"); if (s0) { s0.textContent = "flower-poster-renderer.js not loaded — reload the page."; s0.classList.add("is-error"); } } return; }

  var $ = function (id) { return document.getElementById(id); };
  var canvas = $("ba-canvas"), cctx = canvas ? canvas.getContext("2d", { alpha: true }) : null;
  var statusEl = $("ba-status"), pane = document.querySelector('[data-view-pane="bouquet-admin"]');

  // Bouquet and Vase share NOTHING: every switch between them starts from a brand-new
  // state built here (each product's own tuning then comes back from its own snapshot /
  // published file in init()). Never copy a field across.
  function freshBA(r) { return {
    sizeKey: "50x70", styleKey: "", people: [],
    // Poster language for the flowers line ("VIOL / ROS" vs "VIOLET / ROSE").
    // Mirrors the storefront's POSTER_LANG; set from the order's _poster_language on import.
    lang: "sv",
    globalScale: r.DEFAULT_GLOBAL_SCALE || 1.6, stemCutoffPx: 0,
    selected: null, coarse: false, loadedJson: null, lastBouquet: null,
    // Writing the BASE layer moves the flower in every arrangement at once, so it is
    // armed deliberately and never the default -- an accidental all-positions edit costs
    // a whole tuning session to undo.
    baseMode: false,
    // Multi-bouquet orders: every flower-bouquet line item of the last looked-up
    // order, so you can hop between them without refetching.
    importRecs: [], importIdx: -1, importOrderNo: "", importDone: {}, importBaseline: ""
  }; }
  var BA = freshBA(R);
  var CAT = null, FLOWERS = {}, BG_LIST = [], NEUTRAL_LEAF = null, flowerKeyToId = {}, flowerAliasToId = {};
  // Vase mode only: the uploaded vases and the ONE placement they all share.
  var VASE_LIST = [], VASE_PLACEMENT = null, VASE_KEY = "";
  var VASE_IMG_KEY = "__vase";
  var VASE_NONE = "__none";   // the explicit "No vase" choice
  var TEXTURE_URL = "", TEXTURE_OPACITY = 0.4, NEUTRAL_STEM = 0;

  // Loose key for cross-locale matching: lowercase, strip accents + non-alphanumerics
  // ("Blomman för dagen" -> "blommanfordagen", "Lily of the Valley" -> "lilyofthevalley").
  function normKey(v) {
    var s = String(v == null ? "" : v).toLowerCase();
    s = s.replace(/[åäàáâã]/g, "a").replace(/[öòóôõø]/g, "o").replace(/[éèêë]/g, "e")
         .replace(/[üùúû]/g, "u").replace(/[íìîï]/g, "i").replace(/[ç]/g, "c");
    return s.replace(/[^a-z0-9]+/g, "");
  }

  // ---- Poster language (must mirror flower-poster-section.js flowerDisplayName /
  // posterFlowerName exactly, or a re-export prints different text than the customer saw).
  // The catalog is always fetched from the PRIMARY locale (absolute /products/… path), so
  // `name`/`posterName` are Swedish and `nameEn`/`posterNameEn` hold the English copy.
  function catCardLabel(f) {
    if (!f) return "";
    if (BA.lang === "en" && f.nameEn) return String(f.nameEn);
    if (BA.lang === "no" && f.nameNo) return String(f.nameNo);
    return String(f.name || "");
  }
  function catPosterName(f) {
    if (!f) return "";
    if (BA.lang === "en") return String(f.posterNameEn || f.posterName || f.nameEn || f.name || "");
    // The bouquet has no Norwegian fields; undefined falls through to Swedish, so this is
    // inert there rather than printing blanks.
    if (BA.lang === "no") return String(f.posterNameNo || f.posterName || f.nameNo || f.name || "");
    return String(f.posterName || f.name || "");
  }
  var imgCache = Object.create(null), loaded = false;

  function status(msg, err) { if (!statusEl) return; statusEl.textContent = msg; statusEl.classList.toggle("is-error", !!err); }
  function paneVisible() { return pane && pane.style.display !== "none"; }
  // THE mode. Three things were reachable before -- "this flower type only", "base layout
  // slot" (radios) and "Base position (all setups)" (a toggle button) -- and which one the
  // arrow keys obeyed depended on a combination of them. One switch now, and a line that
  // says in words what the hotkeys will do.
  //   position : this flower, at this position
  //   flower   : this painting's defaults, everywhere it appears
  //   layout   : the slot itself -- moves EVERY flower standing there (1-5 only)
  // escHtml lives in the orders script block -- a separate scope. Calling it from here
  // would throw a ReferenceError and take the whole workbench down, the way an undefined
  // helper did once before.
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  var EDIT_MODE = "position";
  function adjMode() { return EDIT_MODE === "layout" ? "layout" : "flower"; }  // legacy readers
  function editMode() { return EDIT_MODE; }
  function setEditMode(m) {
    EDIT_MODE = m;
    var wrap = document.querySelector(".ba-mode");
    if (wrap) { wrap.className = "ba-mode ba-mode--" + m; }
    // Drives which controls are visible: a panel offering everything at once mostly
    // offers things that do nothing to what you are editing.
    var wb = $("ba-workbench");
    if (wb) { wb.classList.remove("mode-position", "mode-flower", "mode-layout"); wb.classList.add("mode-" + m); }
    root.querySelectorAll(".ba-mode-btn").forEach(function (b) {
      b.classList.toggle("is-active", b.getAttribute("data-mode") === m);
    });
    sayMode();
    if (canvas) canvas.style.outline = (m === "flower") ? "3px solid #c0332c"
                                     : (m === "layout") ? "3px solid #d68a12" : "";
    render();
  }
  function sayMode() {
    var el = $("ba-mode-say"); if (!el) return;
    var sel = BA.selected;
    var who = sel ? (catCardLabel(FLOWERS[sel.key]) || sel.flowerKey) : "a flower";
    var at = sel ? (sel.pos || "") : "";
    var species = !!(sel && sel.speciesCount);
    var lay = $ && root.querySelector('.ba-mode-btn[data-mode="layout"]');
    // There are no slot templates at 6+ -- positions there are the flower's own.
    if (lay) lay.disabled = species;
    if (species && EDIT_MODE === "layout") { setEditMode("position"); return; }
    if (EDIT_MODE === "flower") {
      el.innerHTML = "<b>Default flower scale &mdash; " + esc(who) + ".</b> +/&minus; resizes it and , / . turns it in "
        + "<b>every</b> arrangement it appears in, not just this one. Arrows do nothing in this mode.";
    } else if (EDIT_MODE === "layout") {
      el.innerHTML = "<b>Global position &mdash; " + esc(at) + ".</b> You are moving the spot itself. <b>Every</b> flower "
        + "that ever stands here moves with it, not just " + esc(who) + ".";
    } else {
      el.innerHTML = "<b>" + esc(who) + " at " + esc(at || "this position") + " only.</b> This one flower, this one "
        + "position. Nothing else on the poster moves."
        + (species ? " Saved as <code>" + esc((sel && sel.species) || "flower") + ":" + esc(at) + "</code>." : "");
    }
  }
  root.querySelectorAll(".ba-mode-btn").forEach(function (b) {
    b.addEventListener("click", function () { if (!b.disabled) setEditMode(b.getAttribute("data-mode")); });
  });
  // Show the mode on load, so the first thing you read is what the hotkeys will do.
  setEditMode("position");

  async function loadImg(key, url) {
    if (!url) return null;
    if (imgCache[key] && imgCache[key]._url === url) return imgCache[key];
    var im = new Image(); im.crossOrigin = "anonymous";
    await R.loadImageTo(im, url); im._url = url; imgCache[key] = im; return im;
  }

  // ---- Catalog fetch (from the storefront bouquet product page) ----
  async function fetchCatalogJson() {
    var urls = ["/products/" + HANDLE + "?section_id=" + encodeURIComponent(SECTION), "/products/" + HANDLE];
    for (var i = 0; i < urls.length; i++) {
      try {
        // no-store, deliberately: a plain fetch() serves the product page from the
        // browser HTTP cache, so the workbench could tune against a catalogue captured
        // BEFORE the latest upload -- a vase or flower added minutes ago simply would not
        // be there, with no error to show for it.
        var resp = await fetch(urls[i], { credentials: "same-origin", cache: "no-store" });
        if (!resp.ok) continue;
        var doc = new DOMParser().parseFromString(await resp.text(), "text/html");
        var el = doc.getElementById("fb-flowers-json");
        if (el && el.textContent.trim()) return JSON.parse(el.textContent);
      } catch (e) { /* try next */ }
    }
    throw new Error("Could not read #fb-flowers-json from /products/" + HANDLE + " — check the handle & section id in section settings.");
  }

  async function init() {
    if (loaded) return;
    status("Loading catalog from /products/" + HANDLE + " …");
    try { CAT = await fetchCatalogJson(); }
    catch (e) { status(e.message || String(e), true); return; }

    // The CATALOGUE picks the renderer, not the tab. A payload carrying vases[] or a
    // vasePlacement is a vase poster and has to draw through FlowerVaseRenderer -- the
    // only one that puts a vessel over the flowers. This runs BEFORE the flowers are
    // registered below, because registration writes into whichever renderer R points at;
    // switching afterwards would leave the new renderer with an empty flower registry.
    var wantMode = (CAT && (CAT.vasePlacement || (CAT.vases || []).length)) ? "vase" : "bouquet";
    if (wantMode !== MODE && MODES[wantMode] && MODES[wantMode].renderer()) {
      MODE = wantMode;
      syncVaseLayout();
      R = MODES[wantMode].renderer();
      BA = freshBA(R); imgCache = Object.create(null); _pub = null;
      var _ml = $("ba-mode-label"); if (_ml) _ml.textContent = MODES[wantMode].label;
    }

    FLOWERS = {};
    function registerCat(id, f) {
      FLOWERS[id] = f;
      R.upsertFlower(id, { assetUrl: f.assetUrl, label: catCardLabel(f) || id });
      if (R.upsertFlowerOverride) {
        var ax = Number(f.anchorX); if (!isFinite(ax)) ax = 0.5;
        var ay = Number(f.anchorY); if (!isFinite(ay)) ay = 0.5;
        R.upsertFlowerOverride(id, { stemAnchor: { x: ax, y: ay } });
      }
    }
    (CAT.flowers || []).forEach(function (f) {
      var id = String(f.id);
      registerCat(id, f);
      // A block's SECOND painting (its image_2 setting). The storefront hands it to every
      // other occurrence of a repeated month under the key "<blockId>__v2", so it has to
      // exist here too, for both jobs this tab does: it shows in the palette as its own
      // tile to tune (a different painting has its own offset bucket), and an imported
      // order that used it resolves instead of silently dropping that flower. Only the
      // palette LABEL is marked v2 -- the name printed on the poster stays v1's.
      // Up to four paintings per month, each its own palette tile and its own offset
      // bucket: the flower, its repeat painting, the month's OTHER birth flower, and
      // that one's repeat painting. Two different things share this shape -- "__v2" is
      // the same species painted again, "__b" is a different species the customer picks.
      function variant(sufx, label, url, thumb, posterName, posterNameEn) {
        if (!url) return;
        registerCat(id + sufx, Object.assign({}, f, {
          id: id + sufx,
          flowerKey: String(f.flowerKey || id) + sufx,
          name: f.name ? (f.name + " " + label) : label,
          nameEn: f.nameEn ? (f.nameEn + " " + label) : "",
          // The name PRINTED on the poster follows the species, not the painting.
          posterName: posterName,
          posterNameEn: posterNameEn,
          assetUrl: url,
          thumbUrl: thumb || url
        }));
      }
      variant("__v2", "v2", f.assetUrl2, f.thumbUrl2, f.posterName, f.posterNameEn);
      variant("__b", "(2nd)", f.bAssetUrl, f.bThumbUrl, f.bPosterName, f.bPosterNameEn);
      variant("__b__v2", "(2nd) v2", f.bAssetUrl2, f.bThumbUrl2, f.bPosterName, f.bPosterNameEn);
    });
    flowerKeyToId = {}; flowerAliasToId = {};
    Object.keys(FLOWERS).forEach(function (id) {
      var f = FLOWERS[id];
      if (f.flowerKey) flowerKeyToId[String(f.flowerKey)] = id;
      // Locale-proof fallback index (audit 2026-08-12): Shopify translates the blocks'
      // TEXT settings per locale, so an English order carries flowerKey "june" while this
      // catalog (primary locale) says "juni" — the key lookup then missed and those
      // flowers silently vanished from the import. Index every name we know for a block
      // in BOTH languages so any of them resolves back to the same block id.
      [f.flowerKey, f.name, f.nameEn, f.posterName, f.posterNameEn].forEach(function (v) {
        var k = normKey(v); if (k && !flowerAliasToId[k]) flowerAliasToId[k] = id;
      });
    });
    BG_LIST = (CAT.backgrounds || []).filter(function (b) { return b && b.imageUrl; });
    // Vase mode: the uploaded vases, plus the one placement every vase shares. Absent on
    // the bouquet product, which leaves these empty and the vase row hidden.
    VASE_LIST = (CAT.vases || []).filter(function (v) { return v && v.imageUrl; });
    VASE_PLACEMENT = CAT.vasePlacement || null;
    VASE_KEY = VASE_LIST.length ? String(VASE_LIST[0].key || VASE_LIST[0].id || "") : "";
    NEUTRAL_LEAF = (CAT.neutralLeaf && CAT.neutralLeaf.url) ? CAT.neutralLeaf : null;
    TEXTURE_URL = String(CAT.textureUrl || "");
    TEXTURE_OPACITY = (typeof CAT.textureOpacity === "number") ? CAT.textureOpacity : 0.4;
    NEUTRAL_STEM = Number(CAT.neutralStemCutoff) || 0;

    // Placing flowers against a blank rect is guesswork -- the whole point of this
    // canvas is to position them against the FINISHED design. The vase has no Minimal
    // style any more, so open on its first real background.
    if (MODE === "vase" && BG_LIST.length && !BA.styleKey) {
      BA.styleKey = String(BG_LIST[0].key || BG_LIST[0].id || "");
    }

    syncEngineCapabilities();
    buildStyleOptions();
    buildVaseOptions();
    buildPalette();
    loaded = true;
    var wb = $("ba-workbench"); if (wb) wb.style.display = "grid";
    // Name the RENDERER, not the tab. Everything about the vase depends on R actually
    // being the vase renderer -- the bouquet one silently ignores input.vase -- and that
    // is the one thing you cannot see by looking at the canvas.
    var rname = (R === window.FlowerVaseRenderer) ? "vase"
              : (R === window.FlowerBouquetRenderer) ? "bouquet" : "unknown";
    var vaseWanted = !!(CAT && (CAT.vasePlacement || VASE_LIST.length));
    status((CAT.flowers || []).length + " flowers · " + BG_LIST.length + " background(s) · "
      + VASE_LIST.length + " vase(s) · renderer: " + rname + " · vase: " + (VASE_KEY || "-")
      + " · /products/" + HANDLE, vaseWanted && rname !== "vase");
    if (vaseWanted && rname !== "vase") {
      console.error("[BA] vase catalogue but renderer is " + rname
        + " -- window.FlowerVaseRenderer is " + typeof window.FlowerVaseRenderer);
    }
    autoLoadSnap(); // restore a saved snapshot for the initial style, if any
    syncPublished(); // ...then let a newer PUBLISHED tuning win (async; re-renders if it does)
    applyStyle();
    render();
    // Once webfonts are fully ready, re-render so the footer 1-vs-2-row decision is
    // measured with Gotham (not the wider fallback) — makes preview match the export.
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (loaded) render(); }); } catch (e) {}
  }

  // ---- UI builders ----
  function buildStyleOptions() {
    var sel = $("ba-style"); if (!sel) return;
    // No "no background" on the vase: the background IS the artwork there, and tuning
    // against a blank panel is guesswork. The bouquet keeps Minimal, where it is a real
    // product style rather than a tuning aid.
    var vaseMode = (MODE === "vase" && BG_LIST.length);
    var html = vaseMode ? "" : '<option value="">Minimal (no background)</option>';
    BG_LIST.forEach(function (b) {
      var k = String(b.key || b.id || "");
      // Only the bouquet's backgrounds carry a live flag; the vase's have none, so an
      // absent flag must not read as "draft" on every single one of them.
      var draft = (b.live === false) ? " (draft)" : "";
      html += '<option value="' + k.replace(/"/g, "&quot;") + '">' + (b.name || k).replace(/</g, "&lt;") + draft + "</option>";
    });
    sel.innerHTML = html;
    // Never leave the vase sitting on a blank panel: if the key names no real background,
    // fall to the first one. One uploaded background needs no choosing.
    if (vaseMode && !BG_LIST.some(function (b) { return String(b.key || b.id || "") === BA.styleKey; })) {
      BA.styleKey = String(BG_LIST[0].key || BG_LIST[0].id || "");
    }
    sel.value = BA.styleKey;
  }
  function buildVaseOptions() {
    var row = $("ba-vase-row"), sel = $("ba-vase");
    if (!row || !sel) return;
    row.style.display = VASE_LIST.length ? "" : "none";
    // "No vase" carries an explicit sentinel rather than an empty string, so that an
    // UNSET key can never be mistaken for a deliberate "off". Anything that leaves the
    // key blank falls through to the vase below, which is what you want when a single
    // vase is uploaded: it should just show.
    var html = '<option value="' + VASE_NONE + '">No vase</option>';
    VASE_LIST.forEach(function (v) {
      var k = String(v.key || v.id || "");
      html += '<option value="' + k.replace(/"/g, "&quot;") + '">' + String(v.name || k).replace(/</g, "&lt;") + "</option>";
    });
    sel.innerHTML = html;
    // Default to the first vase whenever the key does not name one -- one uploaded vase
    // needs no choosing.
    if (VASE_KEY !== VASE_NONE && !VASE_LIST.some(function (v) { return String(v.key || v.id || "") === VASE_KEY; })) {
      VASE_KEY = VASE_LIST.length ? String(VASE_LIST[0].key || VASE_LIST[0].id || "") : VASE_NONE;
    }
    sel.value = VASE_KEY;
  }
  function selectedVase() {
    // Deliberately NOT gated on MODE: the loaded catalogue is the source of truth. The
    // bouquet product carries no vases[], so this is empty there anyway, and gating on the
    // tab meant one misfired mode switch silently dropped the vase from the render.
    if (!VASE_LIST.length || VASE_KEY === VASE_NONE) return null;
    for (var i = 0; i < VASE_LIST.length; i++) {
      if (String(VASE_LIST[i].key || VASE_LIST[i].id || "") === VASE_KEY) return VASE_LIST[i];
    }
    return VASE_LIST[0];
  }
  function buildPalette() {
    var box = $("ba-palette"); if (!box) return;
    box.innerHTML = "";
    Object.keys(FLOWERS).forEach(function (id) {
      var f = FLOWERS[id];
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ba-pal-btn";
      var thumb = f.thumbUrl || f.assetUrl || "";
      var label = (catCardLabel(f) || f.flowerKey || id).replace(/</g, "&lt;");
      b.innerHTML = (thumb ? '<img src="' + thumb + '" alt="" loading="lazy">' : '<span class="ba-pal-noimg"></span>') + '<span class="ba-pal-name">' + label + '</span>';
      b.title = "Add " + label;
      b.addEventListener("click", function () { addPerson(id); });
      box.appendChild(b);
    });
  }
  function selectedBg() { return BG_LIST.find(function (b) { return String(b.key || b.id || "") === BA.styleKey; }) || null; }
  function maxForStyle() {
    // Bouquet Admin is a dev surface -> use the DEV cap (fall back to LIVE, then 12).
    var bg = selectedBg() || {};
    // The vase's cap is a SECTION setting -- its Background blocks carry no maxFlowers at
    // all, so reading one off them yielded nothing and the list got trimmed against a
    // number that does not exist.
    var m = isVaseCatalogue()
      ? (CAT && (CAT.maxFlowersDev != null ? CAT.maxFlowersDev : CAT.maxFlowers))
      : (BA.styleKey
          ? (bg.maxFlowersDev != null ? bg.maxFlowersDev : bg.maxFlowers)
          : (CAT && (CAT.neutralMaxFlowersDev != null ? CAT.neutralMaxFlowersDev : CAT.neutralMaxFlowers)));
    m = parseInt(m, 10); if (!(m >= 1)) m = 12;
    // Dev ceiling is 14 (p2c12) -- 13/14 are calibration-only counts, live stays at 12.
    return Math.max(1, Math.min(14, m));
  }

  function renderPeople() {
    var box = $("ba-people"); if (!box) return;
    box.innerHTML = "";
    BA.people.forEach(function (p, i) {
      var f = FLOWERS[p.key] || {};
      var row = document.createElement("div"); row.className = "ba-person";
      var mySlot = personSlot(i);
      var selected = !!(BA.selected && mySlot && BA.selected.pos === mySlot.pos
                        && BA.selected.key === mySlot.key);
      if (selected) row.classList.add("is-selected");
      var cross = document.createElement("button"); cross.type = "button"; cross.className = "ba-cross" + (selected ? " is-active" : "");
      cross.textContent = "✛"; cross.title = "Select this flower — then move it with the keyboard (arrows / +− / , .)";
      cross.addEventListener("click", function () { selectPerson(i); });
      var role = document.createElement("span"); role.className = "ba-role";
      // Card label + the name actually printed on the flowers line, so a mismatch (or a
      // missing English poster name falling back to the month) is visible while tuning.
      var pn = catPosterName(f);
      var cl = catCardLabel(f) || p.key;
      // Label the row with the SPOT the JSON is keyed on, not "Parent 2" -- at 6+ there
      // are no parents and no children, and "Parent 2" named nothing that exists.
      var spot = mySlot ? mySlot.pos : personPos(i);
      if (mySlot && mySlot.speciesCount > 1) spot += " (" + mySlot.speciesIndex + "/" + mySlot.speciesCount + ")";
      role.textContent = spot + " · " + cl +
        (pn && normKey(pn) !== normKey(cl) ? " (" + pn + ")" : "");
      var name = document.createElement("input");
      name.type = "text"; name.placeholder = "Name"; name.value = p.name || "";
      name.addEventListener("input", function () { p.name = name.value; scheduleRender(); });
      var btns = document.createElement("span"); btns.className = "ba-pbtns";
      var up = document.createElement("button"); up.type = "button"; up.textContent = "↑"; up.title = "Move up";
      up.addEventListener("click", function () { movePerson(i, -1); });
      var dn = document.createElement("button"); dn.type = "button"; dn.textContent = "↓"; dn.title = "Move down";
      dn.addEventListener("click", function () { movePerson(i, 1); });
      var rm = document.createElement("button"); rm.type = "button"; rm.textContent = "✕"; rm.title = "Remove";
      rm.addEventListener("click", function () { removePerson(i); });
      btns.appendChild(up); btns.appendChild(dn); btns.appendChild(rm);
      row.appendChild(cross); row.appendChild(role); row.appendChild(name); row.appendChild(btns);
      box.appendChild(row);
    });
  }
  // Position key for the Nth person (parents first, then children) — matches the
  // renderer's slot .pos so we can select a flower from the list, not just the canvas.
  function personPos(i) { return i < 2 ? "parent" + i : "child" + (i - 2); }
  /**
   * The slot a people-list row belongs to. personPos() alone answers this only for the
   * 1-5 layouts: at 6+ a position is "flower2", so matching on "child0" found nothing and
   * the row could neither highlight nor be selected. At 6+ a row is identified by its
   * flower and which occurrence of that flower it is, counted down the list.
   */
  function personSlot(i) {
    var slots = (BA.lastBouquet && BA.lastBouquet.slots) || [];
    var p = BA.people[i];
    if (!slots.length || !p) return null;
    if (slots.some(function (s) { return s.speciesCount; })) {
      var occ = 0;
      for (var j = 0; j <= i; j++) if (BA.people[j].key === p.key) occ++;
      var mine = slots.filter(function (s) { return s.key === p.key; });
      return mine[occ - 1] || null;
    }
    for (var k = 0; k < slots.length; k++) if (slots[k].pos === personPos(i)) return slots[k];
    return null;
  }
  function selectPerson(i) {
    if (!BA.lastBouquet || !BA.lastBouquet.slots || !BA.lastBouquet.slots.length) { status("Render the bouquet first.", true); return; }
    var slot = personSlot(i);
    if (!slot) { status("That flower isn't placed in the current layout.", true); return; }
    // Copy the WHOLE slot. Hand-picking fields here meant every new one the renderer
    // started returning -- comboPos, speciesIndex, speciesCount, bx, by -- was silently
    // dropped, so the nudge wrote to keys nothing reads and the flower would not move,
    // with no error to show for it.
    BA.selected = Object.assign({}, slot);
    renderPeople(); render();
  }
  function addPerson(id) {
    if (!FLOWERS[id]) return;
    var cap = maxForStyle();
    if (BA.people.length >= cap) { status("This style allows max " + cap + " flowers.", true); return; }
    var f = FLOWERS[id]; BA.people.push({ key: id, name: "", cmFactor: f.cmFactor || "1.0", direction: f.direction || "right" }); renderPeople(); render();
  }
  function removePerson(i) { BA.people.splice(i, 1); BA.selected = null; renderPeople(); render(); }
  function movePerson(i, d) { var j = i + d; if (j < 0 || j >= BA.people.length) return; var t = BA.people[i]; BA.people[i] = BA.people[j]; BA.people[j] = t; BA.selected = null; renderPeople(); render(); }

  // ---- Render pipeline (mirrors flower-poster-section.js getInput/getStyle) ----
  // Which paintings actually get drawn, under each flower's repeat rule. One helper, used
  // by BOTH the input builder and the image loader -- if they disagreed about what gets
  // drawn, the loader would fetch the wrong images and the canvas would come up short.
  function baseKeyOf(k) { k = String(k || ""); return k.slice(-4) === "__v2" ? k.slice(0, -4) : k; }

  function resolvedEntries() {
    var people = BA.people.map(function (f) {
      var cf = FLOWERS[f.key] || {};
      return {
        key: f.key,
        flowerKey: cf.flowerKey || f.key,
        stemKey: cf.stemUrl ? ("stem:" + f.key) : null,
        name: f.name || "",
        posterName: catPosterName(cf),
        cmFactor: f.cmFactor || cf.cmFactor || "1.0",
        direction: f.direction || cf.direction || "right"
      };
    });
    var drawn = R.resolveRepeats ? R.resolveRepeats(people, {
      ruleFor: function (k) { return (FLOWERS[baseKeyOf(k)] || {}).repeatRule || "alternate"; },
      v2KeyFor: function (k) { var v2 = baseKeyOf(k) + "__v2"; return FLOWERS[v2] ? v2 : null; },
      maxFor: function (k) { return parseInt((FLOWERS[baseKeyOf(k)] || {}).maxRendered, 10) || 0; }
    }) : people.slice();
    drawn.forEach(function (e, i) { e.role = i < 2 ? "parent" : "child"; e.slotIndex = i < 2 ? i : i - 2; });
    return { people: people, drawn: drawn };
  }

  function buildInput() {
    var bg = selectedBg();
    var res = resolvedEntries();
    return {
      sizeKey: BA.sizeKey,
      headline: ($("ba-headline") && $("ba-headline").value) || "",
      ingress: ($("ba-ingress") && $("ba-ingress").value) || "",
      rectColor: ($("ba-rectcolor") && $("ba-rectcolor").value) || "#ededed",
      globalScale: BA.globalScale,
      stemCutoffPx: BA.stemCutoffPx,
      parentsCount: Math.min(res.drawn.length, 2),
      childrenCount: Math.max(res.drawn.length - 2, 0),
      leaf: (!BA.styleKey && NEUTRAL_LEAF && BA.people.length > 0) ? {
        key: "neutral-leaf",
        x: Number(NEUTRAL_LEAF.x) || 0.5, y: Number(NEUTRAL_LEAF.y) || 0.78,
        scale: Number(NEUTRAL_LEAF.scale) || 0.18, rot: Number(NEUTRAL_LEAF.rot) || 0
      } : null,
      bgPlacement: bg ? {
        anchorX: typeof bg.anchorX === "number" ? bg.anchorX : 0.5,
        anchorY: typeof bg.anchorY === "number" ? bg.anchorY : 0.5,
        scale: typeof bg.scale === "number" ? bg.scale : 1
      } : null,
      // The vase draws over the flowers, so tuning has to see it: a flower that looks
      // wrong on its own may be sitting correctly behind the vessel.
      vase: (function () {
        var v = selectedVase();
        if (!v) return null;
        // A MISSING placement must not mean a missing vase. The renderer defaults and
        // clamps every one of these numbers, so handing it an empty object draws the
        // vase at the default position -- visible and fixable. Requiring the placement
        // here instead dropped the vase silently: it was in the list, its image loaded,
        // so nothing anywhere reported a problem.
        var p = VASE_PLACEMENT || {};
        return {
          key: VASE_IMG_KEY,
          mouthX: Number(p.mouthX),
          mouthY: Number(p.mouthY),
          width: Number(p.width),
          imgMouthX: Number(p.imgMouthX),
          imgMouthY: Number(p.imgMouthY)
        };
      })(),
      // Captions list PEOPLE; flowers list what is DRAWN. Under the "pair" rule those are
      // different counts -- four Junes draw as two images and still name four people.
      flowers: res.drawn,
      captions: res.people
    };
  }
  function buildStyle() {
    return { rectColor: ($("ba-rectcolor") && $("ba-rectcolor").value) || "#ededed", posterBgColor: "#FFFFFF", textColor: "#111111", textureOpacity: TEXTURE_OPACITY, flowerShadow: true, debug: false };
  }
  async function ensureImages() {
    var map = Object.create(null), keys = {};
    // The DRAWN keys, not the people's: a pair-rule flower renders through its v2
    // painting, which no person's key names.
    resolvedEntries().drawn.forEach(function (e) { keys[e.key] = 1; });

    // Every load is INDEPENDENT. This was one unguarded await chain, so a single image
    // that failed threw before the rest ran -- and the vase, sitting last, could silently
    // never reach the canvas however correct its placement was. One bad image should cost
    // that image, not the whole poster.
    async function put(key, url) {
      if (!url) return;
      try { map[key] = await loadImg(key, url); }
      catch (e) { console.warn("[BA] image failed to load: " + key + " <- " + url, e); }
    }

    for (var k in keys) {
      var f = FLOWERS[k]; if (!f) continue;
      await put(k, f.assetUrl);
      await put("stem:" + k, f.stemUrl);
    }
    var vsel = selectedVase();
    if (vsel) await put(VASE_IMG_KEY, vsel.imageUrl);
    var bg = selectedBg();
    if (bg) await put(R.BG_KEY, bg.imageUrl);
    // Texture overlay only on background styles; the vase catalogue carries none.
    if (TEXTURE_URL && BA.styleKey) await put(R.TEXTURE_KEY, TEXTURE_URL);
    if (!BA.styleKey && NEUTRAL_LEAF) await put("neutral-leaf", NEUTRAL_LEAF.url);
    return map;
  }

  // Full reset -> baked style -> loaded overrides (matches applyStyleAdjustments).
  function applyStyle() {
    if (R.resetAllAdjustments) R.resetAllAdjustments();
    if (R.applyBakedStyleOverrides) R.applyBakedStyleOverrides(BA.styleKey || "minimal");
    // Per-style position overrides authored on the storefront style block (mirrors
    // applyStyleAdjustments): baked baseline -> this style's own overridesRaw -> loaded JSON.
    var raw = BA.styleKey ? ((selectedBg() || {}).overridesRaw) : (CAT && CAT.neutralOverridesRaw);
    if (raw && R.setTemplateOverrides) { try { var ov = JSON.parse(raw); if (ov && typeof ov === "object") R.setTemplateOverrides(ov); } catch (e) {} }
    if (BA.loadedJson) {
      try { R.setTemplateOverrides(BA.loadedJson); } catch (e) {}
      if (typeof BA.loadedJson.globalScale === "number") BA.globalScale = BA.loadedJson.globalScale;
    }
    // Stem cutoff matches the storefront's currentStemCutoff(): 0 for background styles
    // (auto-cut at greenery edge), the neutral cutoff for Minimal.
    BA.stemCutoffPx = BA.styleKey ? 0 : NEUTRAL_STEM;
    var _cu = $("ba-cutoff"), _cuv = $("ba-cutoff-val");
    if (_cu) _cu.value = BA.stemCutoffPx;
    if (_cuv) _cuv.textContent = String(BA.stemCutoffPx);
    syncMargins(); syncGscale();
  }

  // Memoized Gotham (GothamPoster) load — the poster names/flowers line. Without this
  // the canvas draws in the RockwellPoster fallback. Quotes + document.fonts.ready make
  // it robust; the hidden GothamPoster span in the markup also forces the @font-face fetch.
  var _fontP = null;
  function baEnsureFont() {
    if (!_fontP) _fontP = (async function () {
      try { if (R.ensureFontLoaded) await R.ensureFontLoaded(); } catch (e) {}
      try { if (document.fonts && document.fonts.load) { await document.fonts.load('400 24px "GothamPoster"'); await document.fonts.ready; } } catch (e) {}
    })();
    return _fontP;
  }

  var _busy = false, _again = false, _rt = null;
  function scheduleRender() { clearTimeout(_rt); _rt = setTimeout(render, 60); }
  async function render() {
    if (!loaded || !cctx) return;
    if (_busy) { _again = true; return; }
    _busy = true;
    try {
      await baEnsureFont();
      var map = await ensureImages();
      var mm = R.SIZE_MM[BA.sizeKey] || R.SIZE_MM["50x70"];
      // Size the canvas to fill the available area BEFORE rendering: setupPreviewCanvas
      // reads the canvas's CSS width, so we must set it explicitly or it stays tiny.
      // Portrait poster -> pick the largest width that fits both the column and the
      // viewport height.
      var ratio = (Number(mm.h) || 700) / (Number(mm.w) || 500);
      var wrap = canvas.parentElement;
      var availH = Math.max(240, window.innerHeight * 0.93 - 16);
      var availW = Math.max(160, (wrap ? wrap.clientWidth : 600) - 20);
      var w = Math.min(availW, availH / ratio);
      canvas.style.width = w + "px";
      canvas.style.aspectRatio = mm.w + " / " + mm.h;
      R.setupPreviewCanvasForSize(canvas, cctx, BA.sizeKey, 2);
      BA.lastBouquet = R.renderPoster(cctx, map, buildInput(), buildStyle());
      // A vase that is selected but absent from the map means its image did not load.
      // Silence here reads as "the vase feature is broken" when it is one bad URL.
      if (selectedVase() && !map[VASE_IMG_KEY]) {
        status("Vase image did not load - check the Vase block's image in the theme editor.", true);
      }
      // Re-sync the selection from the slots just computed. BA.selected is a COPY, so its
      // bx/by went stale the instant a nudge moved the flower -- and base mode adds its
      // step to bx, so every press after the first recomputed from the ORIGINAL base and
      // put the flower back in the same place. It moved once, then looked frozen.
      if (BA.selected && BA.lastBouquet && BA.lastBouquet.slots) {
        for (var _i = 0; _i < BA.lastBouquet.slots.length; _i++) {
          var _s = BA.lastBouquet.slots[_i];
          if (_s.key === BA.selected.key && _s.pos === BA.selected.pos) { BA.selected = Object.assign({}, _s); break; }
        }
      }
      drawSelection();
      refreshJson();
      updateSelInfo();
    } catch (e) { status("Render failed: " + (e && e.message ? e.message : e), true); }
    _busy = false;
    if (_again) { _again = false; render(); }
  }

  // WHAT IS SELECTED, AND WHICH WAY IT FACES.
  //
  // The old overlay was a single dashed ring at 95 * scale * globalScale -- roughly 210px
  // on a 900px canvas, so it sat INSIDE the painting and read as part of the artwork.
  // Nothing drew facing at all, so "which way is this flower pointing" could only be
  // answered one flower at a time, in a panel.
  //
  // Every flower now carries a chip at its centre: its position name and an arrow for the
  // way it actually faces. The selected one is filled and ringed. Facing shown is the
  // RESULT -- the painting's original facing, mirrored if the flower is flipped -- because
  // that is what is on the paper, not what is recorded.
  // all = every flower chipped, sel = only the selected one, off = no text at all.
  // A poster covered in "parent0" and flower names cannot be judged as a poster.
  var LABEL_MODES = ["all", "sel", "off"], LABEL_MODE = "all";
  function drawSelection() {
    if (!BA.lastBouquet || !BA.lastBouquet.slots || !cctx) return;
    var sel = BA.selected;
    cctx.save();
    cctx.textAlign = "center";
    cctx.textBaseline = "middle";

    BA.lastBouquet.slots.forEach(function (slot) {
      var isSel = !!(sel && slot.splitKey === sel.splitKey && slot.tplIndex === sel.tplIndex);
      // The selected flower is always marked. The rest can be hidden, because a poster
      // covered in chips cannot be judged as a poster.
      if (LABEL_MODE === "off" && !isSel) return;
      if (LABEL_MODE === "sel" && !isSel) return;
      var facing = (slot.facing === "left") ? "left" : "right";
      if (slot.flip) facing = (facing === "left") ? "right" : "left";
      var arrow = (facing === "left") ? "◀" : "▶";
      // Name the FLOWER, not just the position. With seven different months every chip
      // read "flower1", because each is its own species' first occurrence -- seven
      // identical labels and no way to tell which one you had hold of. The occurrence
      // number is only worth showing when that flower actually appears more than once.
      var nm = catCardLabel(FLOWERS[slot.key]) || slot.flowerKey || slot.pos || "";
      if (slot.speciesCount > 1) nm += " " + (slot.speciesIndex || 1) + "/" + slot.speciesCount;
      var label = nm + "  " + arrow;

      // "off" keeps the selection visible but silent: ring and crosshair, no words.
      var quiet = (LABEL_MODE === "off");
      if (!quiet) {
      cctx.font = (isSel ? "700 " : "500 ") + (isSel ? 17 : 14) + "px Instrument Sans, system-ui, sans-serif";
      var w = cctx.measureText(label).width + (isSel ? 18 : 14);
      var h = isSel ? 26 : 21;
      var cx = slot.x, cy = slot.y;

      // the chip
      cctx.beginPath();
      if (cctx.roundRect) cctx.roundRect(cx - w / 2, cy - h / 2, w, h, 6);
      else cctx.rect(cx - w / 2, cy - h / 2, w, h);
      cctx.fillStyle = isSel ? "#c0332c" : "rgba(255,255,255,.82)";
      cctx.fill();
      cctx.lineWidth = isSel ? 2 : 1;
      cctx.strokeStyle = isSel ? "#7d1f18" : "rgba(26,23,20,.35)";
      cctx.stroke();
      cctx.fillStyle = isSel ? "#fff" : "rgba(26,23,20,.85)";
      cctx.fillText(label, cx, cy + 1);
      }

      if (!isSel) return;
      if (quiet) w = 0;

      // a ring that sits OUTSIDE the chip, plus a crosshair on the exact anchor point
      cctx.setLineDash([6, 5]);
      cctx.lineWidth = 2.5;
      cctx.strokeStyle = "#c0332c";
      cctx.beginPath();
      cctx.arc(cx, cy, Math.max(46, w / 2 + 22), 0, Math.PI * 2);
      cctx.stroke();
      cctx.setLineDash([]);
      cctx.lineWidth = 1.5;
      cctx.beginPath();
      cctx.moveTo(cx - 34, cy); cctx.lineTo(cx - w / 2 - 4, cy);
      cctx.moveTo(cx + w / 2 + 4, cy); cctx.lineTo(cx + 34, cy);
      cctx.moveTo(cx, cy - 30); cctx.lineTo(cx, cy - h / 2 - 3);
      cctx.moveTo(cx, cy + h / 2 + 3); cctx.lineTo(cx, cy + 30);
      cctx.stroke();

      // who it is, above the ring, so the name is readable without the side panel
      // The chip already names the flower; above the ring say WHICH SPOT it is, since
      // that is the thing the panel and the JSON are keyed on.
      var who = quiet ? "" : (slot.pos || "");
      if (who) {
        cctx.font = "600 15px Instrument Sans, system-ui, sans-serif";
        var ww = cctx.measureText(who).width + 14;
        var wy = cy - Math.max(46, w / 2 + 22) - 16;
        cctx.beginPath();
        if (cctx.roundRect) cctx.roundRect(cx - ww / 2, wy - 11, ww, 22, 5);
        else cctx.rect(cx - ww / 2, wy - 11, ww, 22);
        cctx.fillStyle = "rgba(26,23,20,.88)";
        cctx.fill();
        cctx.fillStyle = "#fff";
        cctx.fillText(who, cx, wy + 1);
      }
    });
    cctx.restore();
  }

  function updateSelInfo() {
    var el = $("ba-sel"); if (!el) return;
    if (!BA.selected) { el.textContent = "Click a flower on the canvas to select it."; syncFacingRow(); return; }
    var f = FLOWERS[BA.selected.key] || {};
    var line = "Selected: " + (catCardLabel(f) || BA.selected.flowerKey) + " @ " + BA.selected.splitKey + ":" + BA.selected.pos;
    if (R.getTemplateJson) {
      var slot = R.getTemplateJson(BA.selected.splitKey)[BA.selected.tplIndex];
      if (slot) line += " — x=" + slot.x.toFixed(3) + " y=" + slot.y.toFixed(3) + " scale=" + (slot.scale || 1).toFixed(2) + " rot=" + (slot.rot || 0).toFixed(2);
    }
    line += " · " + (adjMode() === "flower" ? "flower-only" : "BASE slot") + " · " + (BA.coarse ? "COARSE" : "fine");
    el.textContent = line;
    // species scale readout
    var v = (R.getFlowerScale) ? R.getFlowerScale(BA.selected.flowerKey) : null;
    var fv = $("ba-fscale-val"); if (fv) { fv.textContent = (v == null ? "–" : v.toFixed(2)); fv.style.color = (v != null && Math.abs(v - 1) > 1e-9) ? "#c0332c" : ""; }
    var rv = (R.getFlowerRotation) ? R.getFlowerRotation(BA.selected.flowerKey) : null;
    var rvEl = $("ba-frot-val");
    if (rvEl) { rvEl.textContent = (rv == null ? "–" : rv.toFixed(2)); rvEl.style.color = (rv != null && Math.abs(rv) > 1e-9) ? "#c0332c" : ""; }
    var gn = $("ba-fgroup-name");
    if (gn) gn.textContent = catCardLabel(FLOWERS[BA.selected.key]) || BA.selected.flowerKey;
    var grp = $("ba-fgroup"); if (grp) grp.classList.add("is-live");
    var _sl = BA.selected;
    var _painted = (R.getFlowerDirection && R.getFlowerDirection(_sl.flowerKey))
      || ((FLOWERS[_sl.key] && FLOWERS[_sl.key].direction) === "left" ? "left" : "right");
    var _flipped = R.getFlowerFlip ? R.getFlowerFlip(_sl.flowerKey) : false;
    var _shown = ((_painted === "left") !== !!_flipped) ? "left" : "right";
    // In Global position the buttons report what the SPOT asks for, not what one flower
    // currently shows - otherwise the control and its effect describe different things.
    if (editMode() === "layout" && R.getSlotFacing && !_sl.speciesCount) {
      _shown = R.getSlotFacing(_sl.splitKey + ":" + _sl.pos) || _shown;
    }
    var _L = $("ba-face-left"), _Rt = $("ba-face-right");
    if (_L) _L.classList.toggle("is-active", _shown === "left");
    if (_Rt) _Rt.classList.toggle("is-active", _shown === "right");
    sayMode();
    syncFacingRow();
    syncCopyRow();
    updateCenter();
  }

  // Per-species visual-center picker (anchor for placement + rotation/flip pivot).
  function updateCenter() {
    var wrap = $("ba-center"), img = $("ba-center-img"), dot = $("ba-center-dot"), nm = $("ba-center-name");
    if (!wrap || !img || !dot) return;
    if (!BA.selected) { wrap.style.display = "none"; return; }
    var f = FLOWERS[BA.selected.key];
    if (!f || !f.assetUrl) { wrap.style.display = "none"; return; }
    wrap.style.display = "grid";
    if (nm) nm.textContent = catCardLabel(f) || BA.selected.flowerKey;
    if (img.getAttribute("src") !== f.assetUrl) img.src = f.assetUrl;
    var a = (R.getFlowerAnchor && R.getFlowerAnchor(BA.selected.flowerKey)) ||
            { x: (typeof f.anchorX === "number" ? f.anchorX : 0.5), y: (typeof f.anchorY === "number" ? f.anchorY : 0.5) };
    dot.style.left = (a.x * 100) + "%"; dot.style.top = (a.y * 100) + "%";
  }
  (function () {
    var img = $("ba-center-img"), dot = $("ba-center-dot");
    if (!img) return;
    img.addEventListener("click", function (e) {
      if (!BA.selected || !R.setFlowerAnchor) return;
      var rect = img.getBoundingClientRect();
      var fx = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      var fy = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
      R.setFlowerAnchor(BA.selected.flowerKey, fx, fy);
      if (dot) { dot.style.left = (fx * 100) + "%"; dot.style.top = (fy * 100) + "%"; }
      render();
    });
  })();

  // ---- Selection via canvas click ----
  if (canvas) canvas.addEventListener("click", function (e) {
    if (!BA.lastBouquet || !BA.lastBouquet.slots.length) return;
    var rect = canvas.getBoundingClientRect();
    var designH = R.designHeightFor(BA.sizeKey);
    var x = (e.clientX - rect.left) / rect.width * R.DESIGN_W;
    var y = (e.clientY - rect.top) / rect.height * designH;
    // Nearest flower wins, with no cut-off radius. A 70px limit meant you had to hit the
    // flower's CENTRE -- and a miss set BA.selected to null, so the next arrow key did
    // nothing and it read as "the flower will not move". Clicking the canvas now always
    // selects something, and nothing can silently deselect.
    var best = null, bestD = Infinity;
    BA.lastBouquet.slots.forEach(function (s) { var dd = Math.hypot(x - s.x, y - s.y); if (dd < bestD) { bestD = dd; best = s; } });
    if (best) BA.selected = Object.assign({}, best);
    drawSelectionOnly();
    updateSelInfo();
  });
  function drawSelectionOnly() { render(); }
  if ($("ba-labels")) $("ba-labels").addEventListener("click", function () {
    LABEL_MODE = LABEL_MODES[(LABEL_MODES.indexOf(LABEL_MODE) + 1) % LABEL_MODES.length];
    this.classList.toggle("is-active", LABEL_MODE !== "off");
    this.textContent = LABEL_MODE === "all" ? "Labels: all"
                     : LABEL_MODE === "sel" ? "Labels: selected" : "Labels: off";
    render();
    status(LABEL_MODE === "all" ? "Every flower shows its position and facing."
         : LABEL_MODE === "sel" ? "Only the selected flower is labelled."
         : "Labels off - the selection is a ring only, no text.");
  });

  // ---- Nudge (buttons + keyboard) — identical steps to storefront dev mode ----
  function nudge(kind, big) {
    if (!BA.selected) { status("Select a flower on the canvas first.", true); return; }
    var sel = BA.selected;

    // Which layout this selection belongs to. Only the 6+ layout has no slot templates;
    // the 1-5 layouts do, and moving a p2c2 position is how you move that spot for every
    // flower standing there -- so the slot path stays reachable at those counts.
    var speciesMode = !!sel.speciesCount;
    var MODE_ = editMode();
    var flowerMode = MODE_ !== "layout";

    // 6+ is keyed month_key:flowerN -- ONE spot per painting per occurrence. It used to
    // write sel.comboPos, which is the whole roster of the poster
    // ("aster:1|february:1|...|november:1::flower1"): swap a single flower and every key
    // changed, so the tuning vanished and the flowers fell back to the raw template at
    // scale 1.38. The month_key:flowerN path existed, but only while "Base position"
    // happened to be armed -- so the trap was the default and the model was the opt-in.
    //
    // speciesMode/speciesCount come only from the vase renderer; the bouquet never
    // supplies them, so every branch guarded by them is unreachable for it.
    var offKey = sel.comboPos || (sel.splitKey + ":" + sel.pos);
    var spot = (speciesMode && R.getSpeciesSpot) ? R.getSpeciesSpot(sel.flowerKey, sel.speciesIndex) : null;
    function putSpot(patch) { R.setSpeciesSpot(sel.flowerKey, sel.speciesIndex, patch); }
    if (kind === "up" || kind === "down" || kind === "left" || kind === "right") {
      var d = { up: [0, -1], down: [0, 1], left: [-1, 0], right: [1, 0] }[kind];
      var step = big ? 0.02 : 0.004;
      // Both layouts have a base position, they just key it differently: 5+ by the
      // flower's own count ("3:2"), 1-4 by its number in that count's layout
      // ("flower1"). Guarding base mode to the 5+ path left no way to write the small
      // layouts' base at all.
      if (MODE_ === "flower") { status("“Default flower scale” changes size and angle only — switch to “Flower unique per position” to move it.", true); return; }
      if (MODE_ === "layout" && !speciesMode && R.nudgeSlot) {
        // At 1-5 the base position is the LAYOUT's slot: moving it moves that spot for
        // every flower that stands there. There is no per-flower base at these counts.
        R.nudgeSlot(sel.splitKey, sel.tplIndex, d[0] * step, d[1] * step);
      }
      else if (speciesMode && R.setSpeciesSpot) {
        // Seeded from the STORED spot, not from the last rendered frame. render() is
        // async and _busy-guarded, and it is where BA.selected.bx is refreshed -- so a
        // keypress arriving before the re-sync re-seeded from the OLD position and the
        // flower snapped back. The renderer's own state is authoritative and immediate.
        // sel.bx is only the seed for a spot that has never been positioned.
        var cx = (spot && spot.x != null) ? spot.x : (sel.bx || 0);
        var cy = (spot && spot.y != null) ? spot.y : (sel.by || 0);
        putSpot({ x: cx + d[0] * step, y: cy + d[1] * step });
      }
      else if (flowerMode && R.nudgeFlowerOffset) R.nudgeFlowerOffset(BA.selected.flowerKey, offKey, d[0] * step, d[1] * step, 0);
      else if (!speciesMode && R.nudgeSlot) R.nudgeSlot(BA.selected.splitKey, BA.selected.tplIndex, d[0] * step, d[1] * step);
    } else if (kind === "bigger" || kind === "smaller") {
      var ds = (kind === "bigger" ? 1 : -1) * (big ? 0.08 : 0.02);
      if (MODE_ === "flower" && R.setFlowerScale) {
        // The painting's DEFAULT zoom, everywhere it appears -- not a per-arrangement
        // correction. Each version has its own key, so june__v2 zooms independently.
        R.setFlowerScale(sel.flowerKey, (R.getFlowerScale ? R.getFlowerScale(sel.flowerKey) : 1) + ds);
      }
      else if (speciesMode && spot) putSpot({ scale: spot.scale + ds });
      else if (flowerMode && R.nudgeFlowerOffset) R.nudgeFlowerOffset(BA.selected.flowerKey, offKey, 0, 0, ds);
      else if (!speciesMode && R.nudgeSlotScale) R.nudgeSlotScale(BA.selected.splitKey, BA.selected.tplIndex, ds);
    } else if (kind === "rotl" || kind === "rotr") {
      var dr = (kind === "rotr" ? 1 : -1) * (big ? 0.08 : 0.02);
      if (MODE_ === "flower" && R.setFlowerRotation) {
        R.setFlowerRotation(sel.flowerKey, (R.getFlowerRotation ? R.getFlowerRotation(sel.flowerKey) : 0) + dr);
      }
      else if (speciesMode && spot) putSpot({ rot: spot.rot + dr });
      else if (flowerMode && R.nudgeFlowerOffset) R.nudgeFlowerOffset(BA.selected.flowerKey, offKey, 0, 0, 0, dr);
      else if (!speciesMode && R.nudgeSlotRot) R.nudgeSlotRot(BA.selected.splitKey, BA.selected.tplIndex, dr);
    } else if (kind === "zup" || kind === "zdn") {
      // dz, not z: dz is the layer the draw order actually sorts on.
      if (speciesMode && spot) putSpot({ dz: (spot.dz || 0) + (kind === "zup" ? 1 : -1) });
      else if (R.nudgeFlowerOffset) R.nudgeFlowerOffset(BA.selected.flowerKey, offKey, 0, 0, 0, 0, kind === "zup" ? 1 : -1);
    } else if (kind === "flip") {
      // Mirroring is yours now: the renderer no longer flips a flower for crossing the
      // board's midline, so this is the only thing that does it.
      if (R.toggleFlowerFlip) {
        // A flip is a decision about the ARTWORK -- it faces the wrong way -- so it is
        // stored on the painting, not on a position or a flower count. Keyed per position
        // it was forgotten the moment a flower was added, because the key changed with
        // the count (p2c0 -> p2c1 -> p2c2).
        // Flip changes which way the flower FACES. The block's direction setting is the
        // painting's natural facing, so flipping from "right" gives left and flipping
        // back to "right" draws the artwork untouched -- report the resulting direction
        // rather than a boolean, because the direction is the thing being decided.
        // F now means "turn this position the other way", the same decision the Faces
        // buttons make -- not "toggle a mirror on the painting", which turned every copy.
        var _shownNow = (sel.facing === "left") !== !!sel.flip ? "left" : "right";
        setFaceTo(_shownNow === "left" ? "right" : "left");
        return;
        var _natural = (sel.direction === "left") ? "left" : "right";
        var _facing = ((_natural === "left") !== !!_f) ? "left" : "right";
        status((catCardLabel(FLOWERS[BA.selected.key]) || BA.selected.flowerKey) + " now faces " + _facing
          + (_facing === _natural ? " (as painted)" : " (mirrored)"));
      }
    }
    render();
  }
  root.querySelectorAll("[data-nudge]").forEach(function (b) { b.addEventListener("click", function () { nudge(b.getAttribute("data-nudge"), BA.coarse); }); });

  function onKey(e) {
    if (!loaded || !paneVisible()) return;
    var tag = (document.activeElement && document.activeElement.tagName) || "";
    if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") return;
    if (e.key === "x" || e.key === "X") { e.preventDefault(); setCoarse(!BA.coarse); return; }
    if (!BA.selected) return;
    var big = BA.coarse || e.shiftKey;
    if (e.shiftKey && (e.key === "ArrowUp" || e.key === "ArrowDown")) { e.preventDefault(); nudge(e.key === "ArrowUp" ? "zup" : "zdn"); return; }
    var mv = { ArrowUp: "up", ArrowDown: "down", ArrowLeft: "left", ArrowRight: "right" }[e.key];
    if (mv) { e.preventDefault(); nudge(mv, big); return; }
    if (e.key === "+" || e.key === "=" || e.key === "?") { e.preventDefault(); nudge("bigger", big); return; }
    if (e.key === "-" || e.key === "_") { e.preventDefault(); nudge("smaller", big); return; }
    if (e.key === "," || e.key === "<" || e.key === ";") { e.preventDefault(); nudge("rotl", big); return; }
    if (e.key === "." || e.key === ">" || e.key === ":") { e.preventDefault(); nudge("rotr", big); return; }
    if (e.key === "f" || e.key === "F") { e.preventDefault(); nudge("flip"); return; }
  }
  window.addEventListener("keydown", onKey);

  function setCoarse(v) { BA.coarse = !!v; var f = $("ba-fine"), c = $("ba-coarse"); if (f) f.classList.toggle("is-active", !BA.coarse); if (c) c.classList.toggle("is-active", BA.coarse); updateSelInfo(); }
  // Flip and Base position are VASE concepts: the bouquet mirrors flowers automatically
  // and has no per-flower spots. Both were guarded, so they did not crash -- they just
  // did nothing, silently, which is worse. Disable them when the engine cannot do them.
  // The vase workbench is viewport-locked; the bouquet is not. One class, set from MODE.
  function syncVaseLayout() {
    var g = $("ba-workbench");
    if (g) g.classList.toggle("is-vase", MODE === "vase");
  }
  function syncEngineCapabilities() {
    var canFlip = !!(R && (R.setFlowerFlip || R.toggleFlowerFlip));
    [$("ba-face-left"), $("ba-face-right")].forEach(function (b) {
      if (!b) return;
      b.disabled = !canFlip;
      if (!canFlip) b.title = "The bouquet mirrors flowers automatically by position - only the vase faces by hand.";
    });
    // The bouquet has no per-painting facing: it mirrors by position. Hide the row there
    // rather than leaving a control that silently does nothing.
    syncFacingRow();
  }

  // "Flip" made you work out which way it would end up. You pick the destination now:
  // the flip is derived from where the painting is drawn versus where you want it facing.
  function setFaceTo(dir) {
    var sel = BA.selected;
    if (!sel) { status("Select a flower first.", true); return; }
    var fk = sel.flowerKey;
    // In "Global position" the facing belongs to the SPOT: whatever stands here turns to
    // face this way, however it happens to be painted. Elsewhere it is the painting's own.
    if (editMode() === "layout" && R.setSlotFacing && !sel.speciesCount) {
      var slotKey = sel.splitKey + ":" + sel.pos;
      R.setSlotFacing(slotKey, dir);
      render();
      status(sel.pos + " now wants flowers facing " + dir + " - every flower standing here turns to match.");
      return;
    }
    var painted = (R.getFlowerDirection && R.getFlowerDirection(fk))
      || ((FLOWERS[sel.key] && FLOWERS[sel.key].direction) === "left" ? "left" : "right");
    var want = (dir === "left") ? "left" : "right";

    // The mirror belongs to the POSITION here, not to the painting. Writing the painting's
    // flip turned every occurrence at once -- set flower1 to face right and flower2 turned
    // with it, because both are the same june. The per-position mirror is XORed with the
    // painting's, so it is derived from both: what the painting is, what it is already
    // mirrored to everywhere, and where you want this one pointing.
    // Record the DIRECTION this position wants, not the mirror it currently has. The
    // mirror is recomputed from it, so the JSON says "april faces left" rather than
    // "april is flipped", and stays right if the painting is ever redrawn facing the
    // other way.
    if (sel.speciesCount && R.setSpeciesSpot) {
      R.setSpeciesSpot(fk, sel.speciesIndex, { facing: want });
    } else if (R.setOffsetFacing) {
      R.setOffsetFacing(fk, sel.splitKey + ":" + sel.pos, want);
    } else if (R.setFlowerFlip) {
      R.setFlowerFlip(fk, painted !== want);
    }
    render();
    status((catCardLabel(FLOWERS[sel.key]) || fk) + " at " + sel.pos + " now faces " + want
      + (painted === want ? " (as painted)" : " (mirrored)") + " — this position only.");
  }
  if ($("ba-face-left")) $("ba-face-left").addEventListener("click", function () { setFaceTo("left"); });
  if ($("ba-face-right")) $("ba-face-right").addEventListener("click", function () { setFaceTo("right"); });
  // Start fresh: delete THIS product's snapshot and drop every adjustment. Scoped by
  // snapKey(), so clearing the vase cannot touch the bouquet's saved work.
  if ($("ba-clear-snap")) $("ba-clear-snap").addEventListener("click", function () {
    var which = (MODE === "vase") ? "vase" : "bouquet";
    if (!window.confirm("Delete the saved " + which + " snapshot and reset every adjustment? This cannot be undone.")) return;
    try { localStorage.removeItem(snapKey()); } catch (e) {}
    if (R.resetAllAdjustments) R.resetAllAdjustments();
    BA.loadedJson = null;
    BA.globalScale = R.DEFAULT_GLOBAL_SCALE || 1.6;
    syncGscale();
    refreshSnapStatus();
    render();
    status("Cleared the " + which + " snapshot and reset every adjustment - starting fresh.");
  });

  if ($("ba-fine")) $("ba-fine").addEventListener("click", function () { setCoarse(false); });
  if ($("ba-coarse")) $("ba-coarse").addEventListener("click", function () { setCoarse(true); });

  // Species default scale (opt-in, all positions)
  // Per-painting DEFAULT rotation. It used to be reachable only while Base position was
  // armed, which is a different concept (a position in every setup) -- so an angle that
  // belongs to the artwork was hidden behind a layout mode. Same arm as the scale.
  function speciesRot(dir) {
    if (!BA.selected || !R.setFlowerRotation) { status("Select a flower first.", true); return; }
    var step = BA.coarse ? 0.08 : 0.02;
    R.setFlowerRotation(BA.selected.flowerKey, (R.getFlowerRotation ? R.getFlowerRotation(BA.selected.flowerKey) : 0) + dir * step);
    render(); updateSelInfo();
  }
  if ($("ba-frot-minus")) $("ba-frot-minus").addEventListener("click", function () { speciesRot(-1); });
  if ($("ba-frot-plus")) $("ba-frot-plus").addEventListener("click", function () { speciesRot(1); });
  // No arm switch: the box names the painting it edits, so what these change is visible
  // rather than remembered. It turns red while a flower is selected, because everything
  // inside it applies to that painting at EVERY position, not the one on screen.
  function speciesScale(dir) {
    if (!BA.selected || !R.setFlowerScale) { status("Select a flower first.", true); return; }
    var step = BA.coarse ? 0.1 : 0.02;
    R.setFlowerScale(BA.selected.flowerKey, R.getFlowerScale(BA.selected.flowerKey) + dir * step);
    render();
  }
  // Per-painting DEFAULT facing. The flower block's "Flower direction" setting is the
  // same decision made in the theme editor; this sets it for one painting from here and
  // is saved with the other per-painting defaults. The buttons show the facing in force,
  // whether it came from an override or from the block.
  // Copy a tuned position onto the one you are standing in. copySlotTo() has existed in
  // the renderer all along but nothing called it, so the only way to reuse a position was
  // to re-nudge it by hand in every count layout.
  var COPY_SOURCES = ["p1c0", "p2c0", "p2c1", "p2c2", "p2c3"];
  function syncCopyRow() {
    var row = $("ba-copy-row"), selEl = $("ba-copy-from");
    if (!row || !selEl) return;
    var sel = BA.selected;
    var usable = !!(sel && !sel.speciesCount && R.copySlotTo);
    row.style.display = usable ? "" : "none";
    if (!usable) return;
    var keep = selEl.value;
    var opts = COPY_SOURCES.filter(function (k) { return k !== sel.splitKey; });
    selEl.innerHTML = opts.map(function (k) { return '<option value="' + k + '">' + k + "</option>"; }).join("");
    if (opts.indexOf(keep) >= 0) selEl.value = keep;
  }
  function doCopy(everyFlower) {
    var sel = BA.selected, fromEl = $("ba-copy-from"), from = fromEl && fromEl.value;
    if (!sel || !from || !R.copySlotTo) { status("Select a flower at a 1-5 position first.", true); return; }
    if (everyFlower) {
      var n = 0;
      Object.keys(FLOWERS).forEach(function (id) {
        var fk = (FLOWERS[id] && FLOWERS[id].key) || id;
        if (R.copySlotTo(from, sel.splitKey, sel.pos, fk)) n++;
      });
      render();
      status("Copied " + from + ":" + sel.pos + " onto " + sel.splitKey + ":" + sel.pos + " for every flower (" + n + ").");
    } else {
      var ok = R.copySlotTo(from, sel.splitKey, sel.pos, sel.flowerKey);
      render();
      status(ok ? ("Copied " + from + ":" + sel.pos + " onto " + sel.splitKey + ":" + sel.pos + " for "
                   + (catCardLabel(FLOWERS[sel.key]) || sel.flowerKey) + ".")
                : ("Nothing to copy - " + from + " has no " + sel.pos + "."), !ok);
    }
  }
  if ($("ba-copy-one")) $("ba-copy-one").addEventListener("click", function () { doCopy(false); });
  if ($("ba-copy-all")) $("ba-copy-all").addEventListener("click", function () { doCopy(true); });

  function syncFacingRow() {
    var row = $("ba-fdir-row"), L = $("ba-fdir-left"), Rt = $("ba-fdir-right");
    if (!row || !L || !Rt) return;
    var can = !!(R && R.setFlowerDirection), sel = BA.selected;
    row.style.display = can ? "" : "none";
    L.disabled = Rt.disabled = !(can && sel);
    if (!can || !sel) { L.classList.remove("is-active"); Rt.classList.remove("is-active"); return; }
    var over = R.getFlowerDirection ? R.getFlowerDirection(sel.flowerKey) : null;
    var blockDir = ((FLOWERS[sel.key] && FLOWERS[sel.key].direction) === "left") ? "left" : "right";
    var facing = over || blockDir;
    L.classList.toggle("is-active", facing === "left");
    Rt.classList.toggle("is-active", facing === "right");
    // Say the stored value out loud. The buttons alone could not: is-active had no styling
    // in this box, so the row showed nothing whatever the JSON actually held.
    var note = $("ba-fdir-note");
    if (note) {
      note.textContent = over ? (over + " · saved in directions")
                              : (blockDir + " · from the flower block, not saved");
      note.style.color = over ? "#c0332c" : "";
    }
    L.title = Rt.title = "This painting is drawn facing " + facing
      + (over ? " (set here, saved as directions." + sel.flowerKey + ")" : " (from the flower block)");
  }
  function setFacing(dir) {
    var sel = BA.selected;
    if (!sel || !R.setFlowerDirection) return;
    R.setFlowerDirection(sel.flowerKey, dir);
    render(); syncFacingRow();
    status((catCardLabel(FLOWERS[sel.key]) || sel.flowerKey) + " now faces " + dir + " by default, everywhere it appears.");
  }
  if ($("ba-fdir-left")) $("ba-fdir-left").addEventListener("click", function () { setFacing("left"); });
  if ($("ba-fdir-right")) $("ba-fdir-right").addEventListener("click", function () { setFacing("right"); });
  if ($("ba-fscale-minus")) $("ba-fscale-minus").addEventListener("click", function () { speciesScale(-1); });
  if ($("ba-fscale-plus")) $("ba-fscale-plus").addEventListener("click", function () { speciesScale(1); });

  // ---- Sliders / selects ----
  function syncGscale() { var el = $("ba-gscale"), v = $("ba-gscale-val"); if (el) el.value = BA.globalScale; if (v) v.textContent = BA.globalScale.toFixed(2); }
  var MARGIN_MAP = [["ba-m-top", "ba-m-top-val", "top"], ["ba-m-side", "ba-m-side-val", "side"], ["ba-m-fh", "ba-m-fh-val", "footerHeight"], ["ba-m-fg", "ba-m-fg-val", "footerGap"]];
  function syncMargins() {
    if (!R.getMargins) return; var m = R.getMargins();
    MARGIN_MAP.forEach(function (row) { var el = $(row[0]), v = $(row[1]); if (el && typeof m[row[2]] === "number") { el.value = m[row[2]]; if (v) v.textContent = m[row[2]].toFixed(3); } });
  }
  if ($("ba-size")) $("ba-size").addEventListener("change", function () { BA.sizeKey = this.value; BA.selected = null; render(); });
  // The Bouquet Admin and Vase Admin tabs share this one workbench; the tab bar tells
  // us which poster to work on. Switching is a hard reset: catalogue, palette, tuning
  // tables and the built poster are all per-renderer, with different calibrations, so
  // none of it translates across.
  document.addEventListener("apr:ba-mode", function (e) {
    var m = e && e.detail && e.detail.mode;
    if (!m || m === MODE || !MODES[m]) return;
    var next = MODES[m].renderer();
    if (!next) { status(MODES[m].asset + " not loaded \u2014 reload the page.", true); return; }
    MODE = m; R = next; HANDLE = MODES[m].handle; SECTION = MODES[m].section;
    syncVaseLayout();
    var lbl = $("ba-mode-label"); if (lbl) lbl.textContent = MODES[m].label;
    loaded = false; CAT = null; FLOWERS = {}; BG_LIST = []; NEUTRAL_LEAF = null;
    VASE_LIST = []; VASE_PLACEMENT = null; VASE_KEY = "";
    flowerKeyToId = {}; flowerAliasToId = {};
    BA = freshBA(R); imgCache = Object.create(null); _pub = null;
    ["ba-headline", "ba-ingress", "ba-json"].forEach(function (id) { if ($(id)) $(id).value = ""; });
    if ($("ba-rectcolor")) $("ba-rectcolor").value = "#ededed";
    setEditMode("position"); syncGscale(); renderPeople();
    if ($("ba-pub-status")) $("ba-pub-status").textContent = "";
    var wb = $("ba-workbench"); if (wb) wb.style.display = "none";
    init();
  });

  if ($("ba-vase")) $("ba-vase").addEventListener("change", function () {
    VASE_KEY = this.value || "";
    render();
  });

  if ($("ba-style")) $("ba-style").addEventListener("change", function () {
    BA.styleKey = this.value; BA.selected = null;
    // Minimal always uses the grey rect colour (#ededed) for now.
    if (BA.styleKey === "" && $("ba-rectcolor")) $("ba-rectcolor").value = "#ededed";

    // On the vase a backdrop is just scenery: same flowers, same places. Reloading a
    // per-style snapshot and re-applying per-style overrides would swap the whole
    // arrangement out from under you, and trimming against a per-background cap that no
    // longer exists emptied the list outright.
    if (!isVaseCatalogue()) {
      autoLoadSnap(); // restore this style's saved snapshot (or clear to baseline if none)
      syncPublished();
      var cap = maxForStyle();
      if (BA.people.length > cap) { BA.people = BA.people.slice(0, cap); renderPeople(); status("Trimmed to " + cap + " flowers for this style."); }
      applyStyle();
    }
    render();
  });
  if ($("ba-headline")) $("ba-headline").addEventListener("input", scheduleRender);
  if ($("ba-ingress")) $("ba-ingress").addEventListener("input", scheduleRender);
  if ($("ba-rectcolor")) $("ba-rectcolor").addEventListener("change", scheduleRender);
  if ($("ba-lang")) $("ba-lang").addEventListener("change", function () { setLang(this.value); });

  // Switch the poster language: refresh the renderer's label registry (its fallback when
  // an entry has no posterName), the palette + people labels, then re-render.
  function setLang(lang) {
    BA.lang = (lang === "en" || lang === "no") ? lang : "sv";
    if ($("ba-lang")) $("ba-lang").value = BA.lang;
    if (loaded) {
      Object.keys(FLOWERS).forEach(function (id) {
        var lbl = catCardLabel(FLOWERS[id]);
        if (lbl) R.upsertFlower(id, { label: lbl });
      });
      buildPalette(); renderPeople(); scheduleRender();
    }
  }
  if ($("ba-gscale")) $("ba-gscale").addEventListener("input", function () { BA.globalScale = parseFloat(this.value); var v = $("ba-gscale-val"); if (v) v.textContent = BA.globalScale.toFixed(2); scheduleRender(); });
  if ($("ba-cutoff")) $("ba-cutoff").addEventListener("input", function () { BA.stemCutoffPx = parseFloat(this.value) || 0; var v = $("ba-cutoff-val"); if (v) v.textContent = this.value; scheduleRender(); });
  MARGIN_MAP.forEach(function (row) {
    var el = $(row[0]); if (!el) return;
    el.addEventListener("input", function () { var val = parseFloat(el.value); var v = $(row[1]); if (v) v.textContent = val.toFixed(3); if (R.setMargins) { var patch = {}; patch[row[2]] = val; R.setMargins(patch); } scheduleRender(); });
  });
  root.querySelectorAll('input[name="ba-adjmode"]').forEach(function (r) { r.addEventListener("change", updateSelInfo); });

  // ---- JSON in/out (bake-compatible) ----
  function completeJson() {
    var out = R.getAdjustmentsJson ? (R.getAdjustmentsJson() || {}) : {};
    var baseGs = R.DEFAULT_GLOBAL_SCALE || 1;
    if (Math.abs(BA.globalScale - baseGs) > 1e-9) out.globalScale = BA.globalScale;
    out._style = BA.styleKey || "minimal";
    out._exportedAt = new Date().toISOString();
    out._version = String(R.VERSION || "");
    return out;
  }
  function refreshJson() { var el = $("ba-json"); if (!el || el === document.activeElement) return; var out = completeJson(); el.value = Object.keys(out).length ? JSON.stringify(out, null, 2) : ""; }
  if ($("ba-copy")) $("ba-copy").addEventListener("click", function () {
    var el = $("ba-json"); var out = completeJson(); el.value = JSON.stringify(out, null, 2);
    el.focus(); el.select(); try { navigator.clipboard.writeText(el.value); } catch (e) {}
    status("Adjustments JSON copied (bake-compatible).");
  });
  if ($("ba-dl-json")) $("ba-dl-json").addEventListener("click", function () {
    var out = completeJson();
    if (!Object.keys(out).length) { status("Nothing to download yet — tune something first.", true); return; }
    var txt = JSON.stringify(out, null, 2);
    // Name the file after the product it came from. A vase export called
    // "flower-bouquet-Yellow-....json" is indistinguishable from a bouquet one, which is
    // how a vase snapshot ended up being read as the bouquet's.
    var name = (MODE === "vase" ? "flower-vase-" : "flower-bouquet-") + (BA.styleKey || "minimal") + "-" + Date.now() + ".json";
    try {
      var blob = new Blob([txt], { type: "application/json" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a"); a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
      if ($("ba-json")) $("ba-json").value = txt;
      status("Downloaded " + name + " — hand it to Claude to bake live.");
    } catch (e) { status("Download failed: " + (e && e.message ? e.message : e), true); }
  });
  if ($("ba-load")) $("ba-load").addEventListener("click", function () {
    var el = $("ba-json"); var txt = (el && el.value || "").trim(); if (!txt) { status("Paste a JSON blob into the box first.", true); return; }
    loadJsonText(txt);
  });
  // Replace the current tuning with a JSON text (from the box or an uploaded file).
  function loadJsonText(txt) {
    var parsed; try { parsed = JSON.parse(txt); } catch (e) { status("Invalid JSON: " + e.message, true); return; }
    if (parsed._style && parsed._style !== (BA.styleKey || "minimal")) {
      var target = parsed._style === "minimal" ? "" : parsed._style;
      if (BG_LIST.some(function (b) { return String(b.key || b.id || "") === target; }) || target === "") { BA.styleKey = target; if ($("ba-style")) $("ba-style").value = target; }
    }
    BA.loadedJson = parsed;
    // The JSON's size-of-all-flowers travels with it (absent = the default, which
    // completeJson() leaves out); without this a loaded file rendered at the old size.
    BA.globalScale = (typeof parsed.globalScale === "number") ? parsed.globalScale : (R.DEFAULT_GLOBAL_SCALE || 1.6);
    applyStyle(); render();
    status("Loaded JSON onto style '" + (BA.styleKey || "minimal") + "'. Render should now match the source.");
  }
  // Upload a .json file instead of pasting: read and applied directly, nothing saved.
  if ($("ba-upload-json") && $("ba-json-file")) {
    $("ba-upload-json").addEventListener("click", function () { $("ba-json-file").value = ""; $("ba-json-file").click(); });
    $("ba-json-file").addEventListener("change", function () {
      var file = this.files && this.files[0]; if (!file) return;
      file.text().then(loadJsonText).catch(function (e) { status("Could not read " + file.name + ": " + (e && e.message ? e.message : e), true); });
    });
  }
  if ($("ba-reset")) $("ba-reset").addEventListener("click", function () { BA.loadedJson = null; BA.globalScale = R.DEFAULT_GLOBAL_SCALE || 1.6; applyStyle(); render(); status("Reset to baked baseline for '" + (BA.styleKey || "minimal") + "' (your saved snapshot is untouched — Load snapshot to bring it back)."); });

  // ---- Per-style snapshot (localStorage) — mirrors the storefront dev snapshot: save
  // your admin tuning, auto-restore it on reload, and Load it to revert if a session
  // goes bad. The saved blob is the same bake-compatible JSON, so handing it to Claude
  // to re-bake gives the identical result on the live storefront. ----
  // On the VASE the flowers sit in the same places whatever the backdrop -- the
  // background is scenery behind one arrangement, not a different composition. So its
  // tuning is ONE set, not one per background. The bouquet keeps a snapshot per style,
  // where each style really is its own composition.
  // WHICH PRODUCT AM I. Not "what can the renderer do" -- that asked the wrong
  // question: any capability the bouquet later gains would silently hand it the
  // vase's code paths. MODE is set by the tab you are in and is the only truth.
  function isVaseCatalogue() { return MODE === "vase"; }
  // ONE save state for the bouquet, ONE for the vase. The bouquet keeps its existing
  // per-style keys untouched so every snapshot already saved still loads; the vase
  // gets its own namespace and can never be written into a bouquet slot again.
  function snapKey() { return isVaseCatalogue() ? "ba-snapshot::vase" : ("ba-snapshot::" + (BA.styleKey || "minimal")); }
  // A snapshot carries the product that wrote it. One written by the other product is
  // REFUSED, not loaded: that is how vase tuning ended up driving the bouquet.
  // Unstamped snapshots predate the stamp and are trusted only in bouquet mode,
  // where they were the only writer with a legitimate claim to those keys.
  function readSnap() {
    try {
      var s = JSON.parse(localStorage.getItem(snapKey()) || "null");
      if (!s || !s.adjustments) return null;
      var want = isVaseCatalogue() ? "vase" : "bouquet";
      if (s.product ? (s.product !== want) : (want === "vase")) return null;
      return s;
    } catch (e) { return null; }
  }
  function refreshSnapStatus() {
    var el = $("ba-snap-status"); if (!el) return;
    var s = readSnap(), label = BA.styleKey || "minimal";
    el.textContent = s ? ("● Snapshot for '" + label + "' saved " + (s.savedAt || "earlier") + " — auto-restored on reload.") : ("No snapshot saved for '" + label + "' yet.");
  }
  // A snapshot without globalScale means "the default" (completeJson() leaves it out), so
  // fall back to THIS renderer's default rather than keep whatever was on screen -- that
  // carried the vase's 2.2 into the bouquet when switching tabs.
  function autoLoadSnap() { var s = readSnap(); BA.loadedJson = s ? s.adjustments : null; BA.globalScale = (s && typeof s.adjustments.globalScale === "number") ? s.adjustments.globalScale : (R.DEFAULT_GLOBAL_SCALE || 1.6); syncGscale(); refreshSnapStatus(); }
  if ($("ba-save-snap")) $("ba-save-snap").addEventListener("click", function () {
    try { localStorage.setItem(snapKey(), JSON.stringify({ product: (isVaseCatalogue() ? "vase" : "bouquet"), adjustments: completeJson(), savedAt: new Date().toISOString() })); status("Snapshot saved for '" + (BA.styleKey || "minimal") + "' — restores on reload; overwrite it by saving again."); refreshSnapStatus(); refreshPubStatus(); }
    catch (e) { status("Snapshot save failed: " + (e && e.message ? e.message : e), true); }
  });
  // ---- Published tuning (shared through the Worker) ----
  // The snapshot above lives in ONE browser. Publishing puts the same JSON on the Worker
  // with a timestamp, and every admin's workbench checks it on open: whichever is newer,
  // the published one or this browser's snapshot, wins. A published one that wins is
  // written into the local snapshot too, so everything downstream keeps one source.
  var _pub = null;  // last published record seen for the current product
  function pubProduct() {
    return isVaseCatalogue() ? "vase"
      : ("bouquet-" + String(BA.styleKey || "minimal").toLowerCase().replace(/[^a-z0-9_-]/g, "-")).slice(0, 60);
  }
  function fmtWhen(iso) {
    try { return new Date(iso).toLocaleString("sv-SE", { dateStyle: "short", timeStyle: "short" }); } catch (e) { return iso; }
  }
  function refreshPubStatus(err) {
    var el = $("ba-pub-status"); if (!el) return;
    if (err) { el.textContent = "Published tuning: " + err; return; }
    if (!_pub) { el.textContent = "Nothing published yet — ⬆ Publish shares this tuning with every admin."; return; }
    var s = readSnap();
    var newer = s && s.savedAt && s.savedAt > _pub.publishedAt;
    el.textContent = "⬆ Published " + fmtWhen(_pub.publishedAt) + (_pub.publishedBy ? " by " + _pub.publishedBy : "")
      + (newer ? " · your snapshot is NEWER and not published yet" : "");
  }
  function adoptPublished(p) {
    try { localStorage.setItem(snapKey(), JSON.stringify({ product: (isVaseCatalogue() ? "vase" : "bouquet"), adjustments: p.adjustments, savedAt: p.publishedAt, fromPublished: true })); } catch (e) {}
    BA.loadedJson = p.adjustments;
    // completeJson() leaves globalScale out when it is the default, so absent = default.
    BA.globalScale = (typeof p.adjustments.globalScale === "number") ? p.adjustments.globalScale : (R.DEFAULT_GLOBAL_SCALE || 1.6);
    applyStyle(); render(); refreshSnapStatus();
  }
  async function fetchPublished() {
    if (typeof window.__aprWorkerJson !== "function") throw new Error("sign-in not ready — reload the admin page");
    var d = await window.__aprWorkerJson("/tuning/" + pubProduct());
    return (d && d.published) || null;
  }
  async function syncPublished() {
    var prod = pubProduct();
    var p;
    try { p = await fetchPublished(); } catch (e) { refreshPubStatus("could not check (" + (e && e.message ? e.message : e) + ")"); return; }
    if (prod !== pubProduct()) return;  // switched product/style while the request was out
    _pub = p;
    var s = readSnap();
    if (p && p.adjustments && (!s || !s.savedAt || p.publishedAt > s.savedAt)) {
      adoptPublished(p);
      status("Loaded published tuning from " + fmtWhen(p.publishedAt) + (p.publishedBy ? " (" + p.publishedBy + ")" : "") + ".");
    }
    refreshPubStatus();
  }
  if ($("ba-publish")) $("ba-publish").addEventListener("click", async function () {
    var label = isVaseCatalogue() ? "the Vase" : ("the Bouquet '" + (BA.styleKey || "minimal") + "'");
    if (!window.confirm("Publish this tuning for " + label + "? Every admin's workbench will load it next time it opens.")) return;
    var adj = completeJson();
    try {
      var r = await window.__aprWorkerJson("/tuning/" + pubProduct(), { adjustments: adj });
      _pub = { adjustments: adj, publishedAt: r.publishedAt, publishedBy: r.publishedBy };
      // This browser now holds exactly what was published.
      try { localStorage.setItem(snapKey(), JSON.stringify({ product: (isVaseCatalogue() ? "vase" : "bouquet"), adjustments: adj, savedAt: r.publishedAt, fromPublished: true })); } catch (e) {}
      refreshSnapStatus(); refreshPubStatus();
      status("Published " + fmtWhen(r.publishedAt) + " — other admins get it when they open the workbench.");
    } catch (e) { status("Publish failed: " + (e && e.message ? e.message : e), true); }
  });
  if ($("ba-load-published")) $("ba-load-published").addEventListener("click", async function () {
    try {
      var p = await fetchPublished();
      if (!p || !p.adjustments) { status("Nothing published yet for this product.", true); return; }
      _pub = p; adoptPublished(p); refreshPubStatus();
      status("Loaded published tuning from " + fmtWhen(p.publishedAt) + ".");
    } catch (e) { status("Load published failed: " + (e && e.message ? e.message : e), true); }
  });

  if ($("ba-load-snap")) $("ba-load-snap").addEventListener("click", function () {
    var s = readSnap(); if (!s) { status("No snapshot saved for '" + (BA.styleKey || "minimal") + "'.", true); return; }
    BA.loadedJson = s.adjustments;
    if (typeof s.adjustments.globalScale === "number") BA.globalScale = s.adjustments.globalScale;
    applyStyle(); render(); status("Loaded saved snapshot for '" + (BA.styleKey || "minimal") + "'.");
  });

  // ---- Download print files (PNG / JPG / PDF), same as the storefront dev view ----
  async function doDownload(kind) {
    if (!loaded) { status("Load the catalog first.", true); return; }
    if (!BA.people.length) { status("Add at least one flower first.", true); return; }
    status("Rendering " + kind.toUpperCase() + " …");
    try {
      await baEnsureFont();
      var map = await ensureImages();
      var input = buildInput(), style = buildStyle(), sizeKey = BA.sizeKey;
      // Tag the filename with the order + which bouquet of it this is, so three
      // bouquets from one order don't land in Downloads as indistinguishable files.
      var tag = "";
      if (BA.importOrderNo && BA.importIdx >= 0) {
        tag = "-order" + BA.importOrderNo +
          (BA.importRecs.length > 1 ? "-" + (BA.importIdx + 1) + "of" + BA.importRecs.length : "") +
          "-" + recLabel(BA.importRecs[BA.importIdx]).slice(0, 18);
      }
      var rawBase = "bouquet" + tag + "-" + (BA.styleKey || "minimal") + "-" + sizeKey;
      var base = R.safeFilename ? R.safeFilename(rawBase) : ("bouquet-" + sizeKey);
      var longSide = R.calcPrintLongSide ? R.calcPrintLongSide(sizeKey, 300) : 3000;
      var fname = base, pageLabel = "";
      if (kind === "png") {
        var pu = await R.exportPng({ input: input, imagesByKey: map, style: style, longSide: longSide, sizeKey: sizeKey });
        fname = base + ".png";
        R.downloadDataUrl(pu, fname);
      } else if (kind === "jpg") {
        var ju = await R.exportJpg({ input: input, imagesByKey: map, style: style, longSide: longSide, sizeKey: sizeKey, quality: 0.92 });
        fname = base + ".jpg";
        R.downloadDataUrl(ju, fname);
      } else if (kind === "pdf" || kind === "pdf-nb" || kind === "pdfx4") {
        // "pdfx4" is the Gelato-spec exporter, "pdf"/"pdf-nb" the legacy one.
        // The suffix in the filename keeps the two uploads apart when they are
        // both sent to Gelato for a print comparison.
        var bleed = kind === "pdf-nb" ? 0 : 4;
        var variant = kind === "pdfx4" ? "pdfx4" : "legacy";
        var blob = await R.exportPdf({
          input: input, imagesByKey: map, style: style, size: sizeKey,
          dpi: 300, bleedMm: bleed, variant: variant,
          title: rawBase
        });
        var url = URL.createObjectURL(blob);
        var pmm = R.SIZE_MM[sizeKey] || R.SIZE_MM["50x70"];
        pageLabel = (pmm.w + bleed * 2) + "x" + (pmm.h + bleed * 2) + "mm";
        fname = base + "-300dpi" + (bleed ? "-4mmbleed" : "-nobleed") + "-" + variant +
          "-" + pageLabel + ".pdf";
        var a = document.createElement("a"); a.href = url; a.download = fname;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
      }
      markImportDone();
      var kindLabel = kind === "pdf-nb" ? "PDF (no bleed)" : kind === "pdfx4" ? "PDF/X-4" : kind.toUpperCase();
      // The page size is the only reliable way to tell a bleed file from a no-bleed
      // one on screen: the poster's own paper margin looks like a bleed either way.
      status(kindLabel + " downloaded as " + fname + "." +
        (pageLabel ? " Page " + pageLabel + "." : "") +
        (BA.importRecs.length > 1 ? " Bouquet " + (BA.importIdx + 1) + " of " + BA.importRecs.length + " marked ✓." : ""));
    } catch (e) { status("Download failed: " + (e && e.message ? e.message : e), true); }
  }
  if ($("ba-dl-png")) $("ba-dl-png").addEventListener("click", function () { doDownload("png"); });
  if ($("ba-dl-jpg")) $("ba-dl-jpg").addEventListener("click", function () { doDownload("jpg"); });
  if ($("ba-dl-pdf")) $("ba-dl-pdf").addEventListener("click", function () { doDownload("pdf"); });
  if ($("ba-dl-pdf-nb")) $("ba-dl-pdf-nb").addEventListener("click", function () { doDownload("pdf-nb"); });
  if ($("ba-dl-pdfx")) $("ba-dl-pdfx").addEventListener("click", function () { doDownload("pdfx4"); });

  // ---- Import a customer order's chosen flowers + names into the builder ----
  // An order can hold SEVERAL bouquet line items (e.g. three family bouquets). We keep
  // every one of them and expose a chip per bouquet; the first is applied immediately.
  async function importOrder(q) {
    q = String(q || "").trim(); if (!q) return;
    if (!loaded) { await init(); if (!loaded) return; }
    if (typeof window.__aprLookupOrder !== "function") { status("Order lookup unavailable — reload the admin page.", true); return; }
    status("Looking up order " + q + " …");
    var recs;
    try { recs = await window.__aprLookupOrder(q); }
    catch (e) { status("Lookup failed: " + (e && e.message ? e.message : e), true); return; }
    var bqs = (recs || []).filter(function (r) { return r && isBouquetFamily(r); });
    if (!bqs.length) { status("No flower-bouquet line item found on order " + q + ".", true); return; }
    // Keep only the ones we can actually build (a flower list is required).
    var usable = bqs.filter(function (r) { return recFlowers(r).length; });
    if (!usable.length) { status("Order " + q + " has no flower selections to import.", true); return; }

    BA.importRecs = usable;
    BA.importOrderNo = String((usable[0] && usable[0].order_number) || q);
    BA.importDone = {}; BA.importIdx = -1;
    renderImportChips();
    // "✎ Adjust in Bouquet Admin" on a review card asks for one specific line item —
    // match it so a 3-bouquet order opens on the bouquet you clicked, not always #1.
    var pref = window.__baImportPrefer; window.__baImportPrefer = null;
    var startIdx = 0;
    if (pref) {
      var pk = String(pref.layout_key || ""), pf = String(pref.flowers_json || "");
      for (var i = 0; i < usable.length; i++) {
        if ((pk && String(usable[i].layout_key || "") === pk) || (pf && String(usable[i].flowers_json || "") === pf)) { startIdx = i; break; }
      }
    }
    applyImportRec(startIdx, bqs.length - usable.length);
  }

  function recFlowers(rec) {
    var f;
    try { f = typeof rec.flowers_json === "string" ? JSON.parse(rec.flowers_json) : (rec.flowers_json || []); }
    catch (e) { f = []; }
    return Array.isArray(f) ? f : [];
  }

  // Short human label for one bouquet line item: headline if the customer set one,
  // else the first couple of names, so three bouquets are told apart at a glance.
  function recLabel(rec) {
    var hl = String(rec.headline || "").trim();
    if (hl) return hl;
    var names = recFlowers(rec).map(function (f) { return String(f.name || "").trim(); }).filter(Boolean);
    if (!names.length) return "Untitled";
    return names.slice(0, 2).join(", ") + (names.length > 2 ? " +" + (names.length - 2) : "");
  }

  function renderImportChips() {
    var wrap = $("ba-import-items"), host = $("ba-import-chips");
    if (!wrap || !host) return;
    host.textContent = "";
    if (BA.importRecs.length < 2) { wrap.style.display = "none"; updateImportProgress(); return; }
    wrap.style.display = "flex";
    BA.importRecs.forEach(function (rec, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ba-imp-chip" + (i === BA.importIdx ? " is-active" : "") + (BA.importDone[i] ? " is-done" : "");
      b.appendChild(document.createTextNode((BA.importDone[i] ? "✓ " : "") + (i + 1) + ". " + recLabel(rec) + " "));
      var meta = document.createElement("span");
      meta.className = "ba-imp-meta";
      meta.textContent = "· " + recFlowers(rec).length + " fl · " + (rec.size || "50x70");
      b.appendChild(meta);
      b.title = "Bouquet " + (i + 1) + " of " + BA.importRecs.length + "\n" +
        recFlowers(rec).map(function (f) { return (f.name || "?") + " — " + (f.flowerKey || f.key || "?"); }).join("\n");
      b.addEventListener("click", function () {
        if (i === BA.importIdx) return;
        // Switching bouquets rebuilds the builder from scratch, so unsaved tuning on the
        // current one is lost. Only nag when there IS tuning and no file was downloaded.
        if (BA.importIdx >= 0 && !BA.importDone[BA.importIdx] && adjFingerprint() !== BA.importBaseline &&
            !confirm("Bouquet " + (BA.importIdx + 1) + " has tuning you haven't downloaded yet. Switch to bouquet " + (i + 1) + " and discard it?")) return;
        applyImportRec(i, 0);
      });
      host.appendChild(b);
    });
    updateImportProgress();
  }

  function updateImportProgress() {
    var el = $("ba-import-progress"); if (!el) return;
    var n = BA.importRecs.length;
    if (n < 2) { el.textContent = ""; return; }
    var done = BA.importRecs.filter(function (_, i) { return BA.importDone[i]; }).length;
    el.textContent = "Order #" + BA.importOrderNo + " · " + done + " of " + n + " downloaded";
  }

  // Fingerprint of the current tuning state — compared against the value captured right
  // after an import to tell "untouched" from "hand-tuned" when hopping between bouquets.
  function adjFingerprint() {
    try {
      return JSON.stringify(R.getAdjustmentsJson ? (R.getAdjustmentsJson() || {}) : {}) +
        "|" + BA.globalScale + "|" + BA.stemCutoffPx + "|" + BA.people.map(function (p) { return p.key + ":" + p.name; }).join(",");
    } catch (e) { return ""; }
  }

  function markImportDone() {
    if (BA.importIdx < 0 || BA.importRecs.length < 2) return;
    if (BA.importDone[BA.importIdx]) { updateImportProgress(); return; }
    BA.importDone[BA.importIdx] = true;
    renderImportChips();
  }

  // Apply one bouquet line item to the builder. skipped = bouquet items dropped for
  // having no flower list (reported once, on the initial import).
  function applyImportRec(idx, skipped) {
    var rec = BA.importRecs[idx]; if (!rec) return;
    BA.importIdx = idx;
    var q = BA.importOrderNo;
    var flowers = recFlowers(rec);

    // Set STYLE + SIZE + rect colour FIRST (before adding names) so the flower cap is
    // correct — Original allows more names than Minimal, and orders can have >5.
    // Rule: a grey/white rect colour imports as the Original background style.
    var hasOriginal = BG_LIST.some(function (b) { return String(b.key || b.id || "") === "original"; });
    BA.styleKey = (isGreyOrWhite(rec.rect_color) && hasOriginal) ? "original" : "";
    BA.loadedJson = null;
    if ($("ba-style")) $("ba-style").value = BA.styleKey;
    // Rect colour picked from the order: White if the order's rect is white, else the
    // standard Grey (#ededed) — NOT the order's raw _rect_color hex.
    if ($("ba-rectcolor")) $("ba-rectcolor").value = /^#?(fff|ffffff)$/i.test(String(rec.rect_color || "")) ? "#FFFFFF" : "#ededed";
    // Read the poster size from the order.
    if (rec.size && ["50x70", "40x50", "30x40"].indexOf(String(rec.size)) !== -1) {
      BA.sizeKey = String(rec.size);
      if ($("ba-size")) $("ba-size").value = BA.sizeKey;
    }

    // Poster language comes from the order (_poster_language) — set it BEFORE building
    // people so the labels and the flowers line read in the customer's language.
    setLang(String(rec.poster_language || "").toLowerCase() === "en" ? "en" : "sv");

    var people = [], missing = [];
    flowers.forEach(function (f) {
      // Resolve in order of reliability: the block id (never translated), then the
      // flowerKey index, then a normalized cross-locale alias (month/flower name in
      // either language). Before the alias step, English orders lost every flower whose
      // flowerKey Shopify had translated (audit 2026-08-12).
      var id = null;
      var bid = String(f.key || "");
      if (bid && FLOWERS[bid]) id = bid;
      if (!id) {
        var fk = String(f.flowerKey || f.key || "");
        id = flowerKeyToId[fk] || flowerKeyToId[fk.toLowerCase()] || null;
      }
      if (!id) {
        var cands = [f.flowerKey, f.key, f.cardLabel, f.flowerName];
        for (var ci = 0; ci < cands.length && !id; ci++) {
          var nk = normKey(cands[ci]); if (nk && flowerAliasToId[nk]) id = flowerAliasToId[nk];
        }
      }
      if (id) { var cf = FLOWERS[id] || {}; people.push({ key: id, name: f.name || "", cmFactor: cf.cmFactor || "1.0", direction: cf.direction || "right" }); }
      else missing.push(String(f.flowerKey || f.key || f.cardLabel || "?"));
    });
    if (!people.length) { status("Couldn't match any flowers to the catalog" + (missing.length ? " (order keys: " + missing.join(", ") + ")" : "") + ".", true); return; }
    var cap = maxForStyle(), dropped = 0;
    if (people.length > cap) { dropped = people.length - cap; people = people.slice(0, cap); }
    BA.people = people; BA.selected = null;
    if ($("ba-headline")) $("ba-headline").value = rec.headline || "";
    if ($("ba-ingress")) $("ba-ingress").value = rec.ingress || "";
    renderPeople(); applyStyle(); render();
    BA.importBaseline = adjFingerprint();
    renderImportChips();
    var many = BA.importRecs.length > 1;
    status("Imported order " + (rec.order_number || q) + (many ? " — bouquet " + (idx + 1) + " of " + BA.importRecs.length + " (" + recLabel(rec) + ")" : "") +
      " on " + (BA.styleKey || "minimal") + " · " + BA.sizeKey + " · " + (BA.lang === "en" ? "English" : BA.lang === "no" ? "Norsk" : "Svenska") +
      " — " + people.length + " flower(s)" +
      (dropped ? "; ⚠ " + dropped + " flower(s) DROPPED — over this style's cap of " + cap : "") +
      (missing.length ? "; ⚠ unmatched (missing from the poster): " + missing.join(", ") : "") +
      (skipped ? "; " + skipped + " bouquet line item(s) skipped (no flower list)" : "") +
      (many ? ". Tune + download this one, then click the next chip." : "."));
  }
  // Grey/white rect colour test (near-neutral + light): #E3E1DD, #ededed, #FFFFFF, etc.
  function isGreyOrWhite(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || "")); if (!m) return false;
    var n = parseInt(m[1], 16), r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    return (Math.max(r, g, b) - Math.min(r, g, b)) <= 22 && Math.max(r, g, b) >= 200;
  }
  if ($("ba-import-btn")) $("ba-import-btn").addEventListener("click", function () { importOrder($("ba-import-order") ? $("ba-import-order").value : ""); });
  if ($("ba-import-order")) $("ba-import-order").addEventListener("keydown", function (e) { if (e.key === "Enter") importOrder(e.target.value); });

  // ---- Lazy init on first tab open (+ explicit button) ----
  if ($("ba-init")) $("ba-init").addEventListener("click", init);
  var tabBtn = document.querySelector('.apr-tab[data-view="bouquet-admin"]');
  if (tabBtn) tabBtn.addEventListener("click", function () { if (!loaded) init(); });
});
